export const AUTH_GTM_EVENTS = {
  login: "user-sign-in",
  registration: "user-sign-up",
  logout: "user-log-out",
};
